export const BLOG_URL = "blog";
export const blogByIdUrl = (id) => `blog/${id}`;
export const blogBySlugUrl = (slug) => `blog/slug/${slug}`;
